import React from 'react';
import { DocumentTextIcon, CheckCircleIcon, PencilSquareIcon, ClipboardDocumentCheckIcon } from '@heroicons/react/24/outline';

const CatastropheWelcome = ({ onStart }) => {
  return (
    <div className="shadow rounded-lg overflow-hidden" style={{ backgroundColor: 'var(--succession-bg-primary)', border: '1px solid var(--succession-border)' }}>
      <div className="px-6 py-8 text-white" style={{ background: 'linear-gradient(to right, var(--succession-primary), var(--succession-secondary))' }}>
        <h2 className="text-3xl font-bold mb-2">Business Catastrophe Planning</h2>
        <p className="text-lg font-medium opacity-90">Protect your clients and practice in case of unexpected events</p>
      </div>
      
      <div className="px-6 py-6">
        <p className="mb-6" style={{ color: 'var(--succession-text-secondary)' }}>
          A Business Catastrophe Plan is a critical document for financial advisors and wealth management professionals that outlines 
          what happens to your practice in the event of unforeseen circumstances such as death, disability, or other significant life events.
          This plan ensures your clients continue to receive service and your business value is preserved even if you are unable to continue operating.
        </p>
        
        <div className="mb-6">
          <h3 className="text-lg font-medium mb-3" style={{ color: 'var(--succession-text-primary)' }}>This tool will help you:</h3>
          <ul className="space-y-3">
            <li className="flex items-start">
              <CheckCircleIcon className="h-6 w-6 mr-2 flex-shrink-0" style={{ color: 'var(--succession-success)' }} />
              <span style={{ color: 'var(--succession-text-secondary)' }}>Define clear transfer terms for your practice in case of catastrophic events</span>
            </li>
            <li className="flex items-start">
              <CheckCircleIcon className="h-6 w-6 mr-2 flex-shrink-0" style={{ color: 'var(--succession-success)' }} />
              <span style={{ color: 'var(--succession-text-secondary)' }}>Identify a successor or create a plan to find a suitable partner</span>
            </li>
            <li className="flex items-start">
              <CheckCircleIcon className="h-6 w-6 mr-2 flex-shrink-0" style={{ color: 'var(--succession-success)' }} />
              <span style={{ color: 'var(--succession-text-secondary)' }}>Establish appropriate business valuation methodology for your practice</span>
            </li>
            <li className="flex items-start">
              <CheckCircleIcon className="h-6 w-6 mr-2 flex-shrink-0" style={{ color: 'var(--succession-success)' }} />
              <span style={{ color: 'var(--succession-text-secondary)' }}>Set payment terms and client transition processes to protect your family's interests</span>
            </li>
            <li className="flex items-start">
              <CheckCircleIcon className="h-6 w-6 mr-2 flex-shrink-0" style={{ color: 'var(--succession-success)' }} />
              <span style={{ color: 'var(--succession-text-secondary)' }}>Address compliance and regulatory considerations specific to financial services</span>
            </li>
          </ul>
        </div>
        
        <div className="border rounded-md p-4 mb-6" style={{ backgroundColor: 'var(--succession-info-bg)', borderColor: 'var(--succession-info-border)' }}>
          <div className="flex">
            <DocumentTextIcon className="h-6 w-6 mr-2 flex-shrink-0" style={{ color: 'var(--succession-info)' }} />
            <div>
              <h4 className="text-sm font-medium" style={{ color: 'var(--succession-info)' }}>Important Note</h4>
              <p className="mt-1 text-sm" style={{ color: 'var(--succession-info)' }}>
                This tool will walk you through the steps of identifying your key preferences and generate a template agreement. 
                The resulting document should be reviewed with qualified legal counsel, your compliance department, and your 
                successor partners before implementation. Different financial services firms may have specific requirements for 
                such agreements.
              </p>
            </div>
          </div>
        </div>
        
        <div className="border rounded-md p-4 mb-6" style={{ backgroundColor: 'var(--succession-bg-secondary)', borderColor: 'var(--succession-border)' }}>
          <div className="flex">
            <PencilSquareIcon className="h-6 w-6 mr-2 flex-shrink-0" style={{ color: 'var(--succession-text-tertiary)' }} />
            <div>
              <h4 className="text-sm font-medium" style={{ color: 'var(--succession-text-primary)' }}>How it Works</h4>
              <p className="mt-1 text-sm" style={{ color: 'var(--succession-text-secondary)' }}>
                You'll complete a series of sections covering different aspects of your Business Catastrophe Plan. 
                As you fill out each section, a draft agreement will be generated in real-time. 
                You can review and edit your answers at any time. The questionnaire covers business information, successor details, 
                trigger events, valuation methodology, payment terms, client transition, and legal considerations.
              </p>
            </div>
          </div>
        </div>
        
        <div className="flex justify-center">
          <button
            onClick={onStart}
            className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white focus:outline-none focus:ring-2 focus:ring-offset-2"
            style={{ backgroundColor: 'var(--succession-primary)', focusRingColor: 'var(--succession-primary)' }}
          >
            <ClipboardDocumentCheckIcon className="mr-2 h-5 w-5" />
            Start Creating Your Plan
          </button>
        </div>
      </div>
    </div>
  );
};

export default CatastropheWelcome; 